import React from "react";

const CancelledStampOverlay = () => {
    return (
        <div className="pointer-events-none absolute inset-0 z-10 flex items-start justify-center pt-11 md:pt-12">
            <span className="-rotate-12 rounded-md border-2 border-red-600 bg-red-50/80 px-4 py-1 text-xl font-extrabold uppercase tracking-[0.2em] text-red-700">
                CANCELLED
            </span>
        </div>
    );
};

export default CancelledStampOverlay;